module.exports = __webpack_public_path__ + "img/Treppenabgang.ab8b242e.jpg";